$(document).ready(function () {

  // open links in new window
  $("a[rel~=external]").attr("target","_blank");

  var windowWidth = window.innerWidth;

  if(windowWidth >= 768) {
    var maxHeight = 0;
    $("#our-capsules, #our-story, #press, #careers").imagesLoaded( function() {
      // images have loaded
      $(".match").each(function(){
        if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
      });
      $(".match").height(maxHeight);
    });
  }

  if(windowWidth <= 768) {
    var maxHeight = 300;
    $("#our-capsules, #our-story, #press, #careers, #faqs").imagesLoaded( function() {
      // images have loaded
      $(".section-depth").each(function(){
        if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
      });
      $(".section-depth").height(maxHeight);
    });
  }

  //setting video to always maintain AR
  var videoHeight = windowWidth * 0.5625;

  windowWidth <= 1200 ? $(".responsive-video").css({"height": videoHeight,"width": "100%"}) : $(".responsive-video").css({"height": videoHeight,"width": "1200px"});

  $(window).resize(function (){
    windowWidth <= 1200 ? $(".responsive-video").css({"height": videoHeight,"width": "100%"}) : $(".responsive-video").css({"height": videoHeight,"width": "1200px"});
  });

  // Setting button links without hrefs
  // Allowing for link  to open in new tab
  $(".link-button").click(function(event){
    var link = $(this).data("link");
    if (link != "http://www.keepcapsfromkids.eu/nl") {
      // window.location.replace(link);
      window.location.href = link;
    } else {
      window.open(link,"_blank");
    }
  })

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
{
	def: 'easeInOutCirc',
	swing: function (x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},
	easeInOutQuad: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	},
	easeInQuart: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t + b;
	},
	easeOutQuart: function (x, t, b, c, d) {
		return -c * ((t=t/d-1)*t*t*t - 1) + b;
	},
	easeInOutQuart: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
		return -c/2 * ((t-=2)*t*t*t - 2) + b;
	},
	easeInQuint: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
	},
	easeOutQuint: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},
	easeInOutQuint: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
		return c/2*((t-=2)*t*t*t*t + 2) + b;
	},
	easeInSine: function (x, t, b, c, d) {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: function (x, t, b, c, d) {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInOutSine: function (x, t, b, c, d) {
		return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
	},
	easeInExpo: function (x, t, b, c, d) {
		return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	},
	easeOutExpo: function (x, t, b, c, d) {
		return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function (x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
	},
	easeOutCirc: function (x, t, b, c, d) {
		return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
	},
	easeInOutCirc: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
		return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
	},
	easeInElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},
	easeOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
	},
	easeInOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},
	easeInBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},
	easeInOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},
	easeInBounce: function (x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
	},
	easeOutBounce: function (x, t, b, c, d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		} else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		} else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		} else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},
	easeInOutBounce: function (x, t, b, c, d) {
		if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
	}
});

  // $("#sub-nav-toggle").click(function(e){
  //   e.preventDefault();
  //   $(".sub-nav").toggleClass("open");
  //   $(".about-arrow").toggleClass("open");
  //   setTimeout(function(){
  //     $(".sub-nav").toggleClass("clickable");
  //   }, 100)
  // });

  // $(".sub-nav--desktop").each( function () {
  //   var $this = $(this);
  //   // ?? open this link
  //   var $menuToToggle;
  //   var $thisArrow = $this.find(".about-arrow");
  //   // ?? close the other
  //   var $otherMenu = $(".sub-nav--desktop").not($this);
  //   var $otherArrows = $(".about-arrow").not($thisArrow);

  //   $this.click( function (link) {
  //     link.preventDefault();
  //     $menuToToggle = "#" + $this.data("toggle");
  //     $otherToggle = $(".sub-nav").not($menuToToggle);

  //     // ?? close others
  //     $otherArrows.removeClass("open");
  //     $otherMenu.removeClass("open");
  //     $otherToggle.removeClass("clickable");

  //     // ? open this
  //     $($menuToToggle).toggleClass("open");
  //     $thisArrow.toggleClass("open");

  //     setTimeout(function(){
  //       $($menuToToggle).toggleClass("clickable");
  //     }, 100)
  //   })
  // })

  $(".sub-nav--desktop").click( function (event) {
    event.preventDefault();

    var $this = $(this);
    var $menuToToggle = "#" + $this.data("toggle");
    var $thisArrow = $this.find(".about-arrow");

    var $otherArrow = $(".about-arrow").not($thisArrow),
        $otherMenu = $(".sub-nav").not($menuToToggle);

    $otherArrow.removeClass("open");
    $otherMenu.removeClass("open clickable");

    $($menuToToggle).toggleClass("open");
    $thisArrow.toggleClass("open");
    setTimeout(function () {
      $($menuToToggle).toggleClass("clickable");
    }, 100)
  });

  // ! mobile nav subnav toggles
  var $thisToggleTarget;
  $(".sub-nav-toggle").click(function(e){
    $thisToggleTarget = $(this).data("nav-toggle");

    console.log($thisToggleTarget);

    e.preventDefault();

    $("nav").each( function (i) {
      if ($(this).hasClass($thisToggleTarget)) {
        $(this).toggleClass("closed");
        $(this).toggleClass("open");
      }
    });

    $(".about-arrow").toggleClass("open");
    setTimeout(function(){
      $(".sub-nav").toggleClass("clickable");
    }, 100)
  });

  // Region Selector
  $('.region-selector').click(function() {
    $('.region-selector__submenu').toggle();
    $(".region-selector__arrow").toggleClass("open");
  });

  // // Password reset form fix
  // $("#RecoverPassword").click(function(){
  //   $("#RecoverPasswordForm").show();
  // });

  getHash = function () {
    return window.location.hash;
  };

  // Customer Pages
  var $recoverPasswordLink     = $('#RecoverPassword'),
      $hideRecoverPasswordLink = $('#HideRecoverPasswordLink'),
      $recoverPasswordForm     = $('#RecoverPasswordForm'),
      $customerLoginForm       = $('#CustomerLoginForm'),
      $passwordResetSuccess    = $('#ResetSuccess');

  loginForms = function() {
    function showRecoverPasswordForm() {
      $recoverPasswordForm.show();
      $customerLoginForm.hide();
    }

    function hideRecoverPasswordForm() {
      $recoverPasswordForm.hide();
      $customerLoginForm.show();
    }

    $recoverPasswordLink.on('click', function(evt) {
      evt.preventDefault();
      showRecoverPasswordForm();
    });

    $hideRecoverPasswordLink.on('click', function(evt) {
      evt.preventDefault();
      hideRecoverPasswordForm();
    });

    // Allow deep linking to recover password form
    if (getHash() == '#recover') {
      showRecoverPasswordForm();
    }
  };

  resetPasswordSuccess = function() {
    $passwordResetSuccess.show();
  };

  loginForms();

  var clicks = "0";

  /* Question Page */
  // Toggle radio inputs on 'Button' clicks
  var splatterOne = function (s) {
    $("#" + s).click(function () {
      var $otherButton1 = $(".button-container-1").find(".input").not($(this));

      if ($(this).hasClass("active")) {
        return true;
      } else {
        $(this).addClass("active");
        $("#" + s).addClass("button-clicked");
        $("#" + s + " .inner-button").addClass("inner-clicked").delay(500).addClass("clicked");
        $("#" + s + " .splats").addClass("outer-clicked");
      }
      if ($otherButton1.hasClass("active")) {
        $otherButton1.removeClass("active");
      }
    });
  }

  var splatterTwo = function (s) {
    $("#" + s).click(function () {
      var $otherButton2 = $(".button-container-2").find(".input").not($(this));

      if ($(this).hasClass("active")) {
        return true;
      } else {
        $(this).addClass("active");
        $("#" + s).addClass("button-clicked");
        $("#" + s + " .inner-button").addClass("inner-clicked").delay(500).addClass("clicked");
        $("#" + s + " .splats").addClass("outer-clicked");
      }
      if ($otherButton2.hasClass("active")) {
        $otherButton2.removeClass("active");
      }
    });
  }

  var splatterTextOne = function (s) {
    $("#" + s + "-text").click(function () {
      var $link = $(this).data("value");

      if ($link == "bio") {
        var $otherButton = $("#non-bio");
        if ($otherButton.hasClass("active")) {
          $otherButton.removeClass("active");
        }

        $("#bio").addClass("active");
        $("#" + s).addClass("button-clicked");
        $("#" + s + " .inner-button").addClass("inner-clicked").delay(500).addClass("clicked");
        $("#" + s + " .splats").addClass("outer-clicked");
      } else if ($link == "non-bio") {
        var $otherButton = $("#bio");
        if ($otherButton.hasClass("active")) {
          $otherButton.removeClass("active");
        }

        $("#non-bio").addClass("active");
        $("#" + s).addClass("button-clicked");
        $("#" + s + " .inner-button").addClass("inner-clicked").delay(500).addClass("clicked");
        $("#" + s + " .splats").addClass("outer-clicked");
      } else {
        console.log("!");
      }

    });
  }

  var splatterTextTwo = function (s) {
    $("#" + s + "-text").click(function () {
      var $link = $(this).data("value");

      if ($link == "one-capsule") {
        var $otherButton = $("#two-capsules");
        if ($otherButton.hasClass("active")) {
          $otherButton.removeClass("active");
        }
        $("#one-capsule").addClass("active");
        $("#" + s).addClass("button-clicked");
        $("#" + s + " .inner-button").addClass("inner-clicked").delay(500).addClass("clicked");
        $("#" + s + " .splats").addClass("outer-clicked");
      } else if ($link == "two-capsules") {
        var $otherButton = $("#one-capsule");
        if ($otherButton.hasClass("active")) {
          $otherButton.removeClass("active");
        }
        $("#two-capsules").addClass("active");
        $("#" + s).addClass("button-clicked");
        $("#" + s + " .inner-button").addClass("inner-clicked").delay(500).addClass("clicked");
        $("#" + s + " .splats").addClass("outer-clicked");
      } else {
        console.log("!");
      }
    });
  }

  // Calculate number of inputs on the page

  splatterOne("bio");
  splatterTextOne("bio");
  splatterOne("non-bio");
  splatterTextOne("non-bio");

  splatterTwo("one-capsule");
  splatterTextTwo("one-capsule");
  splatterTwo("two-capsules");
  splatterTextTwo("two-capsules");

  $(".logged-in-landing").click(function(){
    setTimeout(function(){
      $("#questions").scrollTo("#logged-in-landing", 1000);
    }, 600);
  })

  // Show machine-size on bio/ non-bio select
  $("#bio, #non-bio, #bio-text, #non-bio-text").click(function () {
    $("#machine-size").addClass("visible");
    setTimeout(function(){
      $("#questions").scrollTo("#machine-size", 1000);
    }, 600);
  });

  $("#one-capsule, #two-capsules, #one-capsule-text, #two-capsules-text").click(function () {
    $("#washes-per-week").addClass("visible");
    setTimeout(function(){
      $("#questions").scrollTo("#washes-per-week", 1000);
    }, 600);
  });

  // FAQ accordion
  var $faq = $(".faq-title");
  var $thisBody;
  var $otherBodies;
  var $otherTitles;
  var $faqPosition;

  $faq.click(function() {
    $otherTitles = $faq.not($(this));
    $thisBody = $(this).next();
    $otherBodies = $(".faq-body").not($thisBody);
    if ($otherBodies.hasClass("open")) {
      $otherBodies.removeClass("open");
    }
    if ($otherTitles.hasClass("active-faq")) {
      $otherTitles.removeClass("active-faq");
    }
    $thisBody.toggleClass("open");
    $(this).toggleClass("active-faq");
  });

  var $faqGroup = $(".faq-group h2");

  $faqGroup.click( function () {
    var $this = $(this).parent();

    $this.toggleClass("faq-group-open");
    $(".faq-group").not($this).removeClass("faq-group-open");
  })

  // Mobile burger menu
  $(".burger").click(function(){
    $(".nav-drop-menu").toggleClass("open-burger");
    $(".burger-lines").toggleClass("open");
  });

  // ? mobile nested menus
  $(".has-drop-down").each( function () {
    var $this = $(this);

    $this.click( function () {
      $otherNestedMenus = $(".has-drop-down").not($this);
      $otherNestedMenus.removeClass("open");
      $this.toggleClass("open");
    })
  })

  var topHowItWorks = $("#how-it-works").offset();

  // Scroll to how it works section
  $(".to-how-it-works").click(function () {
    setTimeout(function () {
      $("html").scrollTo("#how-it-works", 1000);
    }, 200, {
      easing: 'easeInOutCirc'
    });
  });

  // Scroll to how it works section
  $(".to-eco-friendly-1").click(function () {
    setTimeout(function () {
      $("html").scrollTo("#eco-friendly-1", 1000);
    }, 200, {
      easing: 'easeInOutCirc'
    });
  });

  $(".to-big-performance").click(function () {
    setTimeout(function () {
      $("html").scrollTo("#big-performance", 1000);
    }, 200, {
      easing: 'easeInOutCirc'
    });
  });

  $(".to-dishwash-safety").click(function () {
    setTimeout(function () {
      $("html").scrollTo("#dishwash-safety", 1000, {offset:-84});
    }, 200, {
      easing: 'easeInOutCirc'
    });
  });

  $(".to-laundry-safety").click(function () {
    setTimeout(function () {
      $("html").scrollTo("#laundry-safety", 1000, {offset:-84});
    }, 200, {
      easing: 'easeInOutCirc'
    });
  });

  $(".to-faqs").click(function () {
    setTimeout(function () {
      $("html").scrollTo("#faqs", 1000, {offset:-84});
    }, 200, {
      easing: 'easeInOutCirc'
    });
  });


  // Carousel settings
  $("#testimonials .owl-carousel").owlCarousel({
    loop: true,
    margin: 10,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        dots: true
      },
      1000: {
        items: 3
      }
    }
  })

  $("#press .owl-carousel").owlCarousel({
    loop: true,
    margin: 10,
    responsive: {
      0: {
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        dots: false
      },
      1000: {
        items: 4
      }
    }
  })

});